module.exports = __webpack_public_path__ + "static/media/rGrijalva.bf09e196.jpeg";